import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppBar, Container, Stack, Typography, useTheme } from "@mui/material";
import { useContainerSettings } from "../../hooks/UseContainerSettings/useContainerSettings";
import { MuiMarkdown_V2 } from "../MuiMarkdown/MuiMarkdown_V2";
import { StyledToolbar } from "../Navigation/StyledToolbar";
import { TypographyRouterLink } from "../Typographies/TypographyRouterLink";
import { FooterText as FT, PRIVACY_LINK } from "./footer-utils";
import { useFooter } from "./useFooter";
export const Footer = () => {
    const { palette } = useTheme();
    const { containerWidth, isMobile, openedFromMobileApp } = useContainerSettings();
    const F = useFooter();
    return (_jsx(AppBar, Object.assign({ className: "footer-appbar-overrides" }, { children: _jsx(StyledToolbar, Object.assign({ variant: "dense", disableGutters: true }, { children: _jsx(Container, Object.assign({ id: "footer-container", disableGutters: isMobile || openedFromMobileApp ? true : false, maxWidth: containerWidth, sx: {
                    display: "flex",
                    px: isMobile ? 1 : 0,
                } }, { children: _jsxs(Stack, Object.assign({ sx: {
                        flexDirection: {
                            xx: "column",
                            sm: "row",
                        },
                        justifyContent: "space-between",
                        flexGrow: 1,
                    } }, { children: [_jsxs(Stack, { children: [_jsx(Typography, Object.assign({ variant: "body2", sx: {
                                        textAlign: {
                                            xx: "center",
                                            sm: "left",
                                        },
                                    } }, { children: F.allRightsReserved })), _jsx(Typography, Object.assign({ variant: "body3", sx: {
                                        textAlign: {
                                            xx: "center",
                                            sm: "left",
                                        },
                                    } }, { children: F.buildVersion }))] }), _jsxs(Stack, { children: [_jsx(MuiMarkdown_V2, Object.assign({ linkTypographyVariant: "body2", 
                                    // This component does not, currently, tap into the theme directly, as it is
                                    // not a MUI component. We can take another look to see if this is something that we can fix.
                                    // But until then, we pick up the theme via useTheme and pass it in for the palette.
                                    sx: {
                                        display: "block",
                                        color: palette.primary.contrastText,
                                        textAlign: {
                                            xx: "center",
                                            sm: "right",
                                        },
                                    } }, { children: F.replacedFooter })), F.companyUsesSMS && (_jsx(TypographyRouterLink, Object.assign({ variant: "body3", to: PRIVACY_LINK, sx: {
                                        textAlign: {
                                            xx: "center",
                                            sm: "right",
                                        },
                                    } }, { children: FT.PRIVACY })))] })] })) })) })) })));
};
